import { getIsLoggedIn, updateMenu } from 'actions/auth/login';
import { put, select } from 'redux-saga/effects';
import { getClientCode } from 'actions/ui/init/initSelectors';
import { getLocale } from 'actions/language/selectors';
import { push } from 'react-router-redux';
import { pushDangerNotification } from 'actions/notification/notification';
import { ERROR_ACCESS_DENIED, ERROR_BAD_INPUT } from 'lib/errorTypes';

/* TODO
    - Investigate the various Redux store fields with the name 'error'. These don't seem
        to do anything and might have to be removed.
*/

const DEFAULT_ERROR =
  'Oops! Something went wrong, please try again and contact us if the issue continues.';

const createErrorMessage = (messages = DEFAULT_ERROR, title = '') => ({
  title,
  messages
});

/* Error Processors

    Use these to create error messages for specific situations
    like form submission or login.
 */
export const createFormErrorMessage = (errorTitle, errorMessages) => {
  const defaultMessage = ['Please enter valid information and try again.'];

  switch (errorTitle) {
    case ERROR_BAD_INPUT: {
      if (!errorMessages || errorMessages.length <= 0) {
        return createErrorMessage(defaultMessage);
      }

      // Handles validation for changing of own permissions and deactivation of accounts
      if (!errorMessages[0].key || errorMessages[0].key === 'active') {
        return createErrorMessage(errorMessages.map((error) => error.message));
      }

      // Handles validation for Edit/Create account form fields
      let bulletedErrors = errorMessages.map((error) => '• ' + error.message);
      return createErrorMessage(defaultMessage.concat(bulletedErrors));
    }
    default:
      return createErrorMessage();
  }
};

export const createLoginErrorMessage = (errorTitle, errorMessages) => {
  switch (errorTitle) {
    case ERROR_BAD_INPUT:
      return createErrorMessage(errorMessages);
    case ERROR_ACCESS_DENIED:
      return createErrorMessage(
        'Incorrect email or password. Please try again.'
      );
    default:
      return createErrorMessage();
  }
};

/* Formatted pushDangerNotification

    Formats your error data to be user-friendly before dispatching.
    Use this instead of pushDangerNotification.
 */
export function* pushFormattedError(err, fn = () => createErrorMessage()) {
  if (err.id == ERROR_ACCESS_DENIED) {
    const locale = yield select(getLocale);
    const clientCode = yield select(getClientCode);
    const isLoggedIn = yield select(getIsLoggedIn);

    if (isLoggedIn) {
      yield put(push(`/${locale}/${clientCode}/home`));
    }
    yield put(updateMenu());
  }

  yield put(pushDangerNotification(fn(err.id, err.messages)));

  if (['local', 'development'].includes(process.env.NODE_ENV)) {
    // Log errors to console for easier debugging in local and dev environments.
    // `pushDangerNotification(createErrorMessage())` does NOT yield helpful
    // output when facing generic JavaScript errors; they do not set a message/id
    // and instead give the `DEFAULT_ERROR`.
    /* eslint no-console: 0 */
    console.error(err);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/formValidationHelper/formValidationMessage.js